
import { getContrastRatio, hexToRgb } from '@mui/material'

export function ensureHexFormat(color: string) {
  return /^#?[0-9a-f]{3,6}$/i.test(color) && (color.indexOf('#') === 0 ? color : `#${color}`)
}

export const getClassColorByContrast = (color: string, darkClass: string, lightClass: string) => {
  if (!color) {
    return lightClass
  }

  const contrastRatio = getContrastRatio(hexToRgb(color), 'rgb(255, 255, 255)')
  return contrastRatio > 4 ? lightClass : darkClass
}